// Shared helpers for the bespoke building prefab groups (buildings_extra_*.ts):
// the voxel `box()` builder and the stone / wood palette they all use.
//
// Voxel scale: 1/16 world unit per voxel. A standard 5×5 tile building is
// 80×80 world units — these prefabs render around 1 hex tile wide.

import type { BlockVoxel } from './types.js';

/** Optional per-voxel material overrides passed to `box()`. */
export interface VoxelMaterialOpts {
  readonly roughness?: number;
  readonly metalness?: number;
  readonly emissive?: string;
}

export function box(
  sx: number,
  sy: number,
  sz: number,
  w: number,
  h: number,
  d: number,
  color: string,
  type?: string,
  opts?: VoxelMaterialOpts,
): BlockVoxel[] {
  const out: BlockVoxel[] = [];
  for (let x = sx; x < sx + w; x++) {
    for (let y = sy; y < sy + h; y++) {
      for (let z = sz; z < sz + d; z++) {
        out.push({ x, y, z, color, ...(type ? { type } : {}), ...opts });
      }
    }
  }
  return out;
}

export const STONE = '#7a7a7a';
export const DARK_STONE = '#4a4a4a';
export const WOOD = '#5a3a1a';
export const DARK_WOOD = '#3a2010';
